import { render, staticRenderFns } from "./cooperation-contract-agreement.vue?vue&type=template&id=785a536c&scoped=true&"
import script from "./cooperation-contract-agreement.vue?vue&type=script&lang=js&"
export * from "./cooperation-contract-agreement.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-contract-agreement.vue?vue&type=style&index=0&id=785a536c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a536c",
  null
  
)

export default component.exports